module.exports = __webpack_public_path__ + "static/media/correctPhoto.47d0e355.jpg";